import { Injectable } from '@angular/core';
import { FormulariosInfo145Response } from '../models/formulariosInfo145';
import { DatosExcel } from 'src/app/shared/ExportadorFicheros/models/datos-excel';
import { ExportadorExcelService } from 'src/app/shared/ExportadorFicheros/services/exportador-excel.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class DescargarExcelFormulariosService {

  constructor(private exportadorExcelService: ExportadorExcelService, private _snackBar: MatSnackBar) { }

  montarExcelFormularios(response: FormulariosInfo145Response[]): Promise<void>{
    const gruposPorDocumentoVersion = new Map<string, FormulariosInfo145Response[]>();
    response?.forEach((item) => {
      const idTipoDocumento = item?.TipoDocumento?.IdTipoDocumento;
      const version = item?.TipoDocumento?.Version;
      const clave = `${idTipoDocumento}-${version}`;
      const grupoActual = gruposPorDocumentoVersion.get(clave) ?? [];
      grupoActual.push(item);
      gruposPorDocumentoVersion.set(clave, grupoActual);
    });

    const ficheros = Array.from(gruposPorDocumentoVersion.values()).map((grupo) => {
      const columnas = this.GetColumnsExportExcelFormularios(grupo);
      const datosExcel = this.montarParametrosExcelFormularios(columnas, grupo);
      const rows = this.GetRowsExportExcelFormularios(grupo, columnas);
      return { configuracion: datosExcel, rows };
    });

    const fecha = new Date();
    const nombreZip = `Hire&Sign_formularios_${fecha.getFullYear()}${fecha.getMonth()+1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.zip`;

    return this.exportadorExcelService.exportaExcelZip(ficheros, nombreZip)
      .catch((error: any) => {
        const mensaje = error?.message ?? error;
        console.error("Error exportando formularios a zip", mensaje);
        this._snackBar.open(`Error exportando formularios a zip: ${mensaje}`, 'Cerrar',{duration: 4000});
      });
  }

  montarParametrosExcelFormularios(columnas: any[], response: FormulariosInfo145Response[]): DatosExcel{
    const tipoDocumento = response?.[0]?.TipoDocumento;
    const version = tipoDocumento?.Version ?? 'SinVersion';
    const sufijoVersion = ` - ${version}`;
    const nombreDocumentoLimpio = (tipoDocumento?.Nombre ?? 'Formularios')
      .replace(/[\\\/\?\*\[\]\:]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    const maxLongitudNombre = Math.max(1, 31 - sufijoVersion.length);
    const nombreRecortado = nombreDocumentoLimpio.slice(0, maxLongitudNombre).trim();
    const workSheetName = `${nombreRecortado}${sufijoVersion}`.slice(0, 31);
    const nombreFichero = `${nombreDocumentoLimpio}${sufijoVersion}`.trim() || `Formularios${sufijoVersion}`;
    let datosExcel = {
      workSheetName,
      nombreFichero:`${nombreFichero}.xlsx`,
      columnas
    }
    return datosExcel
  }

  private GetColumnsExportExcelFormularios(response: FormulariosInfo145Response[]): any[] {
    const columnasBase = [
      'TipoFirmante',
      'NombreEmpresa',
      'CodigoEmpleado',
      'NifEmpleado',
      'NombreEmpleado',
      'ApellidosEmpleado',
      'FechaEnvio',
      'FechaFirma'
    ];

    const columnasValores: string[] = [];
    response?.forEach((tipoDocumento) => {
      tipoDocumento?.Datos?.forEach((dato) => {
        dato?.Valores?.forEach((valor) => {
          const nombreColumna = (valor?.NombreMostrar ?? valor?.SignautreCustomId)?.trim();
          if (nombreColumna && !columnasValores.includes(nombreColumna)) {
            columnasValores.push(nombreColumna);
          }
        });
      });
    });

    return [...columnasBase, ...columnasValores].map((nombreColumna) => ({
      name: nombreColumna,
      filterButton: true,
      width: 180
    }));
  }

  private GetRowsExportExcelFormularios(response: FormulariosInfo145Response[], columnas: any[]): any[] {
    const nombresColumnas = columnas.map((x: any) => x.name);
    const rows: any[] = [];

    response?.forEach((tipoDocumento) => {
      tipoDocumento?.Datos?.forEach((dato) => {
        const valoresPorNombre: Record<string, string> = {};
        dato?.Valores?.forEach((valor) => {
          const nombreColumna = (valor?.NombreMostrar ?? valor?.SignautreCustomId)?.trim();
          if (nombreColumna) {
            valoresPorNombre[nombreColumna] = valor?.Valor ?? '';
          }
        });

        const fila = nombresColumnas.map((nombreColumna: string) => {
          switch (nombreColumna) {
            case 'TipoFirmante': return dato?.TipoFirmante?.Nombre ?? '';
            case 'NombreEmpresa': return dato?.NombreEmpresa ?? '';
            case 'CodigoEmpleado': return dato?.CodigoEmpleado ?? '';
            case 'NifEmpleado': return dato?.NifEmpleado ?? '';
            case 'NombreEmpleado': return dato?.NombreEmpleado ?? '';
            case 'ApellidosEmpleado': return dato?.ApellidosEmpleado ?? '';
            case 'FechaEnvio': return dato?.FechaEnvio ? new Date(dato?.FechaEnvio).toLocaleDateString('es-ES') : '';
            case 'FechaFirma': return dato?.FechaFirma ? new Date(dato?.FechaFirma).toLocaleDateString('es-ES') : '';
            default: return valoresPorNombre[nombreColumna] ?? '';
          }
        });

        rows.push(fila);
      });
    });

    return rows;
  }
}
